import { getCardTypeListApi } from '@/api/completeInfo.js';

const state = {
  completeList: [],
  cardTypeList: [],
  countryList: [],
  countryBack: false,
};

const getters = {
  get_completeInfo_list: state => state.completeList,
  get_cardType_list: state => state.cardTypeList,
  get_country_list: state => state.countryList,
  get_countryBack: state => state.countryBack,
};

const mutations = {
  set_completeInfo_list: (state, data) => {
    state.completeList = data;
  },
  set_cardType_list: (state, data) => {
    state.cardTypeList = data;
  },
  set_countryBack: (state, data) => {
    state.countryBack = data;
  },
  set_country_list: (state, data) => {
    state.countryList = data;
  },
};

const actions = {
  post_cardType_list: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      if (state.cardTypeList.length) resolve();
      getCardTypeListApi().then(res => {
        const { code, data } = res || {};
        if (code === 200 && data?.length) {
          commit(
            'set_cardType_list',
            data.map(item => item.value),
          );
          resolve();
        } else {
          reject();
        }
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
